module.exports = __webpack_public_path__ + "static/media/b_icon_04.c97da43f.png";